import React from 'react';
import { SlidePage } from '../index';
import { BodyContainer, Spacer } from '../styles';

const VocationOnePresentationPage = ({ user, background, number }) => {
  return (
    <SlidePage number={number} background={background}>
      <BodyContainer>
        <div className='right-content'>
          <h1>
            ¡Hola <span className='capitalized'>{user.name.toLowerCase()}</span>
            !
          </h1>
          <p className='justified'>
            El presente informe resume los resultados que obtuviste tras
            responder el Test Vocation Start. Este test está diseñado{' '}
            <strong>
              para apoyar tu paso de educación básica a educación media
            </strong>
            , entregándote información sobre tus principales{' '}
            <strong>recursos, fortalezas y aspectos que puedes mejorar</strong>{' '}
            para enfrentar de forma exitosa los desafíos de esta nueva etapa.
          </p>

          <h2>Aproximaciones al estudio</h2>
          <p className='justified'>
            Vocation Start te entrega información respecto de{' '}
            <strong>la forma en que estudias y aprendes</strong>, identificando
            qué te motiva a estudiar, y qué estrategias de estudio usas con
            mayor frecuencia. La motivación para estudiar o aprender y la forma
            en que normalmente estudias pueden influir positiva o negativamente
            en el logro de los objetivos que te propongas para tu nueva etapa
            escolar. Por ello{' '}
            <strong>
              es importante identificar qué es lo que te motiva a aprender y si
              acaso tus estrategias de estudio son (o no) las más apropiadas.
            </strong>
          </p>

          <h2>Teorías personales sobre el desarrollo de habilidades</h2>
          <p className='justified'>
            Vocation Start indaga en tus creencias sobre{' '}
            <strong>si es posible (o no) mejorar tus habilidades</strong> (como
            las habilidades para las matemáticas, el deporte, las ciencias,
            etc.). La forma en que cada uno de nosotros entiende o piensa sobre
            sus habilidades afecta el tiempo y el esfuerzo que se invierte en
            mejorarlas, lo que puede tener efectos relevantes en tus resultados
            académicos.
          </p>

          <h2>Incertidumbre ante la Transición Académica</h2>
          <p className='justified'>
            El paso a la educación media implica una serie de cambios y un
            aumento de la exigencia, que a veces puede ser abrumador. Vocation
            Start te entrega información sobre{' '}
            <strong>
              cuán preocupado te sientes respecto de estos cambios
            </strong>
            , para que puedas trabajar sobre estas preocupaciones por ti mismo/a
            o con el apoyo de otras personas.
          </p>
          <h2>Recursos para la Transición Escolar</h2>
          <p className='justified'>
            Es muy importante identificar y valorar aquellos{' '}
            <strong>aspectos positivos con los que cuentas</strong> para
            afrontar de mejor forma el paso de la educación básica a media.
            Vocation Start te ayuda a identificar estos aspectos positivos, como
            la autoeficacia, el optimismo o la resiliencia.
          </p>
        </div>
      </BodyContainer>
    </SlidePage>
  );
};

export default VocationOnePresentationPage;
